// extracted by mini-css-extract-plugin
export default {"SimplifiedActionsToolbar":"SimplifiedActionsToolbar_SimplifiedActionsToolbar__jy8WS"};